<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-modal jps-modal-input"
      dialog-width="40rem"
      dialog-max-height="40rem"
    >
      <template #header>
        {{ ls({ ja: 'インポート', en: 'Import' }) }}
      </template>
      <div class="jps-modal-content">
        <BaseUpload
          @update:model-value="selectFile($event)"
          :message="{
            ja: 'JSONファイル(.json)またはJSONLファイル(.jsonl)を選択してください',
            en: 'Selecte JSON or JSONL file',
          }"
        />
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.close) }}</button>
        <button @click="confirm()" :disabled="!file || file.length === 0">{{ ls(dapLangGlobal.ok) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()
const { setLoading } = useLoader()

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  file.value = null
  return await modal.value.openAwait<any>()
}
defineExpose({ openAwait })

interface Props {
}
const props = withDefaults(defineProps<Props>(), {})

const file: Ref<File[]> = ref(null)

const selectFile = (f: File[]) => {
  file.value = f
}

const confirm = () => {
  if (file.value && file.value.length > 0) {
    const fileReader = new FileReader()
    setLoading(true)
    fileReader.onload = () => {
      let string = fileReader.result as string
      if (string.split('\n').length > 1) {
        modal.value.resolve(string.split('\n').map(s => {
          try {
            return JSON.parse(s)
          } catch (e) {
            console.error('parse error', e)
          }
        }))
      } else {
        modal.value.resolve(JSON.parse(string))
      }
    }
    fileReader.readAsText(file.value[0])
  }
}
</script>

<style lang="scss" scoped>
.jps {
  .jps-modal-input {
    .jps-modal-content {
      padding-top: 0;
    }
    input,
    textarea {
      width: 100%;
    }
  }
}
</style>
